import { Label, _decorator } from 'cc';
import { DEV, EDITOR } from 'cc/env';
import LocaleDataSet from '../../../I18n/LocaleDataSet';
import SupportLanguage from '../../../I18n/SupportLanguage';
import { fillTextArgument } from '../../Utils/Utility';
import LocalizedComponent from './LocalizedComponent';

const { ccclass, property, menu } = _decorator;

export type LocalizedStringLanguage = { [value in SupportLanguage]: string };

@ccclass('LocalizedString')
@menu('Internationalization/LocalizedString')
export default class LocalizedString extends LocalizedComponent<Label> implements LocaleDataSet<string> {
    @property
    eng = '';
    @property
    sch = '';
    @property
    tch = '';
    @property
    hkt = '';
    @property
    ko = '';
    @property
    ja = '';
    @property
    id = '';
    @property
    pt = '';
    @property
    es = '';
    @property
    vi = '';
    @property
    th = '';
    @property
    ms = '';
    @property
    fil = '';
    @property
    hi = '';
    @property
    tr = '';
    @property
    ru = '';
    @property
    bn = '';
    @property
    my = '';
    @property
    de = '';

    @property
    private _string: string = '';

    @property({ tooltip: DEV && '會替換各語系中{0}為string的值' })
    public get string(): string {
        return this._string;
    }
    public set string(value: string) {
        if (this._string === value) {
            return;
        }
        this._string = value;
        this.updateString();
    }

    public loadConfig(config: LocalizedStringLanguage) {
        Object.entries(config).forEach(([key, value]) => {
            this[key] = value;
        });
        this.updateString();
    }

    protected getTarget(): Label {
        return this.getComponent(Label);
    }

    protected onLanguageChange() {
        this.updateString();
    }

    protected updateString() {
        if (EDITOR) {
            return;
        }
        const lang = this.i18n.currentLanguage ? this.i18n.currentLanguage : this.i18n.initLanguage;
        this.target.string = fillTextArgument(this[lang], [this.string]);
    }
}
